import {takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {tablesAction} from 'utils/tables';

import {adminAction, GetSubordinateUnassignedRolesAction} from '../action';

const tableId = 'roleSubordinateUnassignedRoles';

function* execute(action: GetSubordinateUnassignedRolesAction): SagaIterator {
    const {tableDataRequest, roleId} = action.payload;
    yield* put(tablesAction.getTableData({
        tableDataRequest,
        apiRequest: Api.getRolesUnassignedToRole,
        successAction: adminAction.getSubordinateUnassignedRolesSuccess,
        tableId,
        pathParams: {
            roleId,
        },
    }));
}

/** Runs the admin saga that loads subordinate roles available for assignment to the selected role. */
export function* getSubordinateUnassignedRolesSaga(): SagaIterator {
    yield takeLatestF('admin/GET_SUBORDINATE_UNASSIGNED_ROLES', execute);
}
